import type { RegistrationHistoryItem, RegistrationHistoryResponse } from '@/services/registrationService'
import { canAccessRegistrationByPurchaseOrder } from '@/lib/purchaseOrderAccess'

export type OnlineCourseStatus = 'Not Started' | 'In Progress' | 'Awaiting Evaluation' | 'Completed' | 'Expired'

export function isOnlineCourseExpired(registration: RegistrationHistoryItem): boolean {
  if (!registration.expirationDate) return false

  const expiryDate = new Date(registration.expirationDate)
  const year = expiryDate.getUTCFullYear()

  // Not expired if not started (2099)
  if (year === 2099) return false

  // Not expired if completed
  if (registration.status?.toLowerCase() === 'completed') return false

  // Check if past expiration date
  const now = new Date()
  now.setHours(0, 0, 0, 0)
  const expiry = new Date(expiryDate)
  expiry.setHours(0, 0, 0, 0)

  return expiry < now
}

export function getOnlineCourseStatus(registration: RegistrationHistoryItem): OnlineCourseStatus {
  if (isOnlineCourseExpired(registration)) return 'Expired'
  if (registration.attended) {
    if (registration.showEvaluationLink) return 'Awaiting Evaluation'
    return 'Completed'
  }
  const cat = registration.onlineCategory?.toLowerCase() || ''
  if (cat === 'inprogress' || cat === 'incomplete') return 'In Progress'
  return 'Not Started'
}

/** Online (SCORM) and Canvas courses the participant has started and can still open. */
export function getInProgressOnlineCourses(history: RegistrationHistoryResponse): {
  online: RegistrationHistoryItem[]
  canvas: RegistrationHistoryItem[]
} {
  const inProgress = (registration: RegistrationHistoryItem) =>
    getOnlineCourseStatus(registration) === 'In Progress' && canAccessRegistrationByPurchaseOrder(registration)
  return {
    online: (history.online ?? []).filter(inProgress),
    canvas: (history.canvas ?? []).filter(inProgress),
  }
}
